import { useEffect } from "react";
import { connect } from "react-redux";
import connectionIconActive from "../../assets/icons/connection-active.svg";
import connectionIcon from "../../assets/icons/connection.svg";
import notificationIconActive from "../../assets/icons/notification-active.svg";
import notificationIcon from "../../assets/icons/notification.svg";
import profileIconActive from "../../assets/icons/profile-active.svg";
import profileIcon from "../../assets/icons/profile.svg";
import ConnectABDM from "../../components/ConnectABDM/ConnectABDM";
import Connections from "../../components/connections/Connections";
import Notification from "../../components/Notification/Notification";
import Profile from "../../components/profile/Profile";
import Header from "../../front-end-global-components/components/Header/Header";
import { isValidObject } from "../../front-end-global-components/services/validators";
import { setNotificationPermission } from "../../redux/app/actions";
import { logout } from "../../redux/authentication/actions";
import {
  setNotificationRead,
  updateNotifications
} from "../../redux/notifications/actions";
import {
  getPatientsRequests,
  setActiveSettingsMenu,
  setAuthModes,
  setRequestsFilterData,
  setTransactionId
} from "../../redux/patients/actions";
import { isValidArray } from "../../utils/validators";
import "./Settings.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import ConditionalRender from "../../front-end-global-components/components/ConditionalRender/ConditionalRender";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import { validDocumentType } from "../../utils/constants";
import { requestsValidation } from "../../utils/requestsValidation";
import AbhaNumber from "../Abdm/AbhaNumber";
import EditProfile from "../Abdm/EditProfile";
import LinkedFacilities from "../Abdm/linkedFacilities";
import ResetPassword from "../Abdm/ResetPassword";
import AbdmQr from "../ShowAbdmInfo/AbdmQr";
import AbdmCard from "../ShowAbdmInfo/AbdmCard";
import AutoApproval from "../Abdm/AutoApproval";
import TokenHistory from "../Abdm/TokenHistory";

function Settings(props) {
  return (
    <Routes>
      <Route path="/*" element={<SettingsComponent {...props} />} />
      <Route path="abdmHealthIdQr" element={<AbdmQr />} />
      <Route
        path="abdmHealthIdCard"
        element={<AbdmCard type="ABHA Address" />}
      />
      <Route
        path="autoApproval/*"
        element={<AutoApproval type="ABHA Address" />}
      />
      <Route
        path="tokenHistory/*"
        element={<TokenHistory type="ABHA Address" />}
      />
      <Route path="editProfile/*" element={<EditProfile />} />
      <Route path="abhaNumber/*" element={<AbhaNumber />} />
      <Route path="linkedFacilities/*" element={<LinkedFacilities />} />
      <Route path="resetPassword" element={<ResetPassword />} />
    </Routes>
  );
}
const getNotificationCount = (profileId, notifications) => {
  if (
    typeof profileId === "string" &&
    notifications?.[profileId] &&
    isValidArray(Object.values(notifications[profileId]))
  ) {
    return Object.values(notifications[profileId]).filter(
      (notification) => !notification.read
    ).length;
  }
  return 0;
};

const SettingsComponent = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (props.patients.activeMenu === null) {
      setActiveSettingsMenu("notification");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <section data-cy="settings-screen" className="inherit-parent-height">
      <Header
        title="Settings"
        backButtonOnClick={() => {
          navigate("/");
        }}
        supportIconOnClick={() => {
          navigate("/query");
        }}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />
      <section
        data-cy="profile-switcher"
        style={{ height: "calc(100% - 64px)" }}
        className="max-width-588px margin-horizontal-auto overflow-hidden padding-top-large position-relative"
      >
        <SettingsMenu
          loading={props.patients.loading}
          userName={
            props.patients.profiles &&
            props.patients.currentProfile &&
            props.patients?.profiles?.[props.patients.currentProfile]?.name
          }
          healthId={
            props.patients.currentProfile &&
            props.patients.profiles?.[props.patients.currentProfile]?.healthId
              ? props.patients.profiles?.[props.patients.currentProfile]
                  .healthId
              : null
          }
          // show={props.patients.p}
          phoneNumber={
            props.patients.profiles &&
            props.patients.currentProfile &&
            props.patients.profiles[props.patients.currentProfile]?.phoneNumber
          }
          notificationCount={
            props.notifications.data &&
            props.patients.currentProfile &&
            getNotificationCount(
              props.patients.currentProfile,
              props.notifications.data
            )
          }
          connectionRequestCount={
            props.clinics?.requests &&
            props.patients.currentProfile &&
            isValidArray(props.clinics.requests)
              ? props.clinics.requests.filter(
                  (request) =>
                    request.recipient === props.patients.currentProfile
                ).length
              : 0
          }
          activeMenu={props.patients.activeMenu}
          menuOnClick={(menuType) => {
            if (props.patients.activeMenu === menuType) return;
            setActiveSettingsMenu(menuType);
          }}
        />

        <ConditionalRender
          condition={props.patients.activeMenu === "connections"}
        >
          <ConditionalRender
            condition={
              props.patients.accessToken &&
              props.patients.currentProfile &&
              props.patients.accessToken?.[props.patients.currentProfile]?.token
                ? true
                : false
            }
          >
            <ConditionalRender
              condition={!props.app.featureFlags?.consentManagement}
            >
              <FeatureFlagsFallback height="settings-screen-content-remaining-height" />
            </ConditionalRender>

            <ConditionalRender
              condition={props.app.featureFlags?.consentManagement}
            >
              <Connections
                connectOnClick={() => {
                  navigate("/abdm/login", { replace: true });
                }}
                loading={props.patients.loading}
                profileId={props.patients.currentProfile}
                fetchAbdmRequests={(options) => {
                  if (
                    props.patients.accessToken?.[props.patients.currentProfile]
                      ?.token
                  ) {
                    getPatientsRequests("ALL", undefined, options);
                  }
                }}
                requests={
                  props.patients.requests &&
                  props.patients.currentProfile &&
                  props.patients.requests[props.patients.currentProfile] &&
                  requestsValidation(
                    props.patients.requests[props.patients.currentProfile],
                    props.patients.autoApprovalPolicies
                  )
                }
                isHealthIdLoggedIn={
                  props.patients.accessToken?.[props.patients.currentProfile]
                    ?.token
                }
                abdmRequestOnClick={(abdmRequestType, abdmRequestId) => {
                  navigate(`/abdm/${abdmRequestType}/${abdmRequestId}`);
                }}
                autoApprovalPolicies={props.patients.autoApprovalPolicies}
                setRequestsFilter={(filterBy, Id) => {
                  setRequestsFilterData(filterBy, Id);
                }}
                filters={props.patients.requestsFilter}
                isUserAgreed={
                  props.patients?.profiles?.[props.patients.currentProfile]
                    ?.consentToPersonalData?.userAgreed
                }
              />
            </ConditionalRender>
          </ConditionalRender>

          <ConditionalRender
            condition={
              !props.patients.accessToken ||
              !props.patients.currentProfile ||
              !props.patients.accessToken?.[props.patients.currentProfile]
                ?.token
            }
          >
            <div className=" profile-setting-height  padding-horizontal-large flex-justify-content-center flex-align-items-center ">
              <ConnectABDM
                connectOnClick={() => {
                  setAuthModes(null);
                  setTransactionId(null);
                  navigate("/abdm/login");
                }}
              />
            </div>
          </ConditionalRender>
        </ConditionalRender>

        {props.patients.loading && props.patients.activeMenu === "profile" && (
          <ProfileSuspense />
        )}

        {!props.patients.loading && props.patients.activeMenu === "profile" && (
          <Profile
            abdmLoggedIn={
              typeof props.patients.accessToken?.[props.patients.currentProfile]
                ?.token === "string"
            }
            isUserAgreed={
              props.patients?.profiles?.[props.patients.currentProfile]
                ?.consentToPersonalData?.userAgreed
            }
            logout={() => {
              navigate("/");
              logout(true);
            }}
          />
        )}
        <Notification
          paginationLoading={props.notifications?.paginationLoading}
          // paginationHandler={() => {
          //   props.notificationPagination(
          //     props.patients.currentProfile,
          //     props.notifications.paginationCount
          //   );
          // }}
          app={props.app}
          onCloseClick={() => {
            setNotificationPermission(false, navigate);
          }}
          loading={props.notifications.loading}
          show={props.patients.activeMenu === "notification"}
          notificationCount={getNotificationCount(
            props.patients.currentProfile,
            props.notifications.data
          )}
          notifications={
            props.notifications.data &&
            props.patients.currentProfile &&
            isValidObject(
              props.notifications.data[props.patients.currentProfile]
            ) &&
            Object.values(
              props.notifications.data[props.patients.currentProfile]
            )
          }
          notificationCardOnClick={(notification) => {
            if (notification?.read === false) {
              setNotificationRead(notification);
            }

            const title = notification?.title || "";
            if (
              notification?.data?.documentType &&
              notification?.data?.documentId
            ) {
              navigate(
                `/patientTimeline/${validDocumentType(
                  notification.data.documentType
                )}/${notification.data.documentId}`
              );
            } else if (title === "Document Received") {
              navigate("/patientTimeline");
            } else if (/consent|subscription/i.test(title)) {
              navigate("/abdm/list");
            }
          }}
          updateNotifications={() => {
            updateNotifications();
          }}
          pagination={
            props.patients.currentProfile &&
            props.notifications.pagination &&
            props.notifications.pagination[props.patients.currentProfile]
          }
          markAllAsReadOnClick={() => {
            setNotificationRead(null, "all");
          }}
        />
      </section>
    </section>
  );
};

const mapStateToProps = (state) => ({
  app: state.app,
  abdm: state.abdm,
  profile: state.profile,
  notifications: state.notifications,
  clinics: state.clinics,
  patients: state.patients
});

export default connect(mapStateToProps)(Settings);

//settings menu component
const SettingsMenu = (props) => {
  const menu = [
    {
      type: "notification",
      icon: notificationIcon,
      activeIcon: notificationIconActive,
      showCount: true,
      countDataCy: "notification-count",
      count: props.notificationCount,
      "data-cy": "NOTIFICATION-MENU"
    },
    {
      type: "profile",
      icon: profileIcon,
      activeIcon: profileIconActive,
      showCount: false,
      countDataCy: "profile-count",
      "data-cy": "PROFILE-MENU"
    },
    {
      type: "connections",
      icon: connectionIcon,
      activeIcon: connectionIconActive,
      countDataCy: "connection-count",
      showCount: true,
      count: props.connectionRequestCount,
      "data-cy": "CONNECTIONS-MENU"
    }
  ];

  const formatPhoneNumber = (phone) => {
    if (typeof phone !== "string") return null;
    return (
      <>
        <span className="padding-right-small">{phone.substring(0, 3)}</span>
        <span className="padding-right-small">{phone.substring(3, 8)}</span>
        <span className="padding-right-small">{phone.substring(8, 13)}</span>
      </>
    );
  };

  const getCountDisplayClasses = (count) => {
    if (count > 99) return "height-and-width-for-triple-digit-number";
    if (count > 9) return "height-and-width-for-double-digit-number";
    return "height-and-width-for-single-digit-number";
  };

  return (
    <>
      <section className="padding-left-medium padding-right-medium flex-justify-content-space-between flex-align-items-center justify-between">
        <div>
          <h3 className="font-size-larger font-family-gilroy-medium font-weight-normal font-color-secondary">
            {props.userName}
          </h3>
          <div className="font-color-secondary font-family-gilroy-medium font-size-small padding-bottom-large padding-top-small">
            {props.healthId || formatPhoneNumber(props.phoneNumber)}
          </div>
        </div>

        <div className="display-flex flex-align-items-center">
          {menu.map((menuItem) => (
            <div
              key={menuItem.type}
              className="display-flex flex-direction-column margin-horizontal-small"
            >
              <div
                data-cy={menuItem["data-cy"]}
                className={`settings-menu-icon-size border-radius-default display-flex flex-align-items-center flex-justify-content-center cursor-pointer ${
                  props.activeMenu === menuItem.type
                    ? "background-color-grey"
                    : "background-color-white"
                } ${menuItem.showCount ? "position-relative" : ""}`}
                onClick={() => props.menuOnClick?.(menuItem.type)}
              >
                <img
                  src={
                    props.activeMenu === menuItem.type
                      ? menuItem.activeIcon
                      : menuItem.icon
                  }
                  alt=""
                  className="settings-menu-icon-height"
                  width="auto"
                />
                {menuItem.count > 0 && menuItem.showCount && (
                  <div
                    data-cy={menuItem.countDataCy}
                    className={`settings-notification-icon-count-size${
                      menuItem.count > 99 ? "-large" : ""
                    } settings-notification-icon-count-position box-shadow-default flex-place-children-page-center border-radius-50-percentage font-color-secondary background-white position-absolute text-align-center font-size-extra-small ${getCountDisplayClasses(
                      menuItem.count
                    )}`}
                  >
                    {menuItem.count > 99 ? "99+" : menuItem.count}
                  </div>
                )}
              </div>
              <span
                className={`padding-top-larger ${
                  props.activeMenu === menuItem.type
                    ? "active-menu-border-bottom-2px-green"
                    : "menu-border-bottom-2px"
                }`}
              />
            </div>
          ))}
        </div>
      </section>
      <div className="settings-menu-horizontal-ruler inherit-parent-width background-white" />
    </>
  );
};

const ProfileSuspense = () => {
  return (
    <section
      className="padding-top-default padding-bottom-large overflow-hidden"
      data-cy="home-page-loading"
    >
      {[...Array(7)].map((_data, index) => (
        <div
          key={index}
          className="padding-top-large padding-left-large padding-right-large"
        >
          <div className="flex-center-children-vertically padding-bottom-default">
            <div className="margin-left-default">
              <div className="shimmer padding-small border-radius-default width-150px ">
                <div className="padding-smaller" />
              </div>
              <div className="shimmer margin-top-default padding-small border-radius-default width-200px " />
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};
